export default {
  "get|user/header/info": (option) => {
    return {
      error: false,
      data: {
        headerInfo: {
          companyName: "Trynibus株式会社",
          userName: "経営企画室",
        },
      },
    };
  },
  "get|user/login/info": (option) => {
    return {
      error: false,
      data: {
        firstLoginFlag: 1,
      },
    };
  },
  "post|user/logout": (option) => {
    return {
      error: false,
    };
  },
  "get|user/company/info": (option) => {
    return {
      error: false,
      data: {
        companyProfileInfo: {},
      },
    };
  },
  "get|v1/business-matching/bm-service-suspension": (option) => {
    return {
      error: false,
      data: {
        bmServicePauseFlag: "1",
      },
    };
  },
  "get|accounts-authority": (option) => {
    return {
      error: false,
      data: {
        authorityType: "",
        authorityInfo: [
          { authorityId: "01", authorityExistence: "1" },
          { authorityId: "02", authorityExistence: "1" },
          { authorityId: "03", authorityExistence: "1" },
        ],
      },
    };
  },
  "get|terms": (option) => {
    return {
      error: false,
      data: {
        termsAgreementInfo: {
          termsOfServiceVer: "1.0",
          privacyPolicyVer: "1.0",
          contactFeatureVer: "1.0",
        },
        secureToken: "",
      },
    };
  },
  "get|common/showUserProfile": (option) => {
    return {
      error: false,
      data: {
        userProfileInfo: {
          userName: "利用規約に同意する",
        },
        secureToken: "",
      },
    };
  },
  "get|accounts/check/master": (option) => {
    return {
      error: false,
      data: {
        masterAccountExistence: "0",
      },
    };
  },
  "put|api/v1/sitecore/updateLoginDate": (option) => {
    return {
      error: false,
      data: {
        firstLoginFlag: "0",
      },
    };
  },
  "get|api/v1/sitecore/getCompanyInfoModificationExistence": (option) => {
    return {
      error: false,
      data: {
        changeCompanyInfoFlag: "1",
      },
    };
  },
  "post|api/v1/core/login": (option) => {
    return {
      error: false,
    };
  },
  "post|Auth0/SetUsercd": (option) => {
    return {
      code: 200,
    };
  },
  "get|api/v1/menus/badge": (option) => {
    return {
      error: false,
      data: {
        menuInfo: {
          home: "1",
          myPage: "1",
          researchInfo: "1",
          library: "1",
          businessMatching: "1",
          spotStaffIntroduction: "1",
          faqContact: "1",
          setting: "1",
        },
      },
    };
  },
  "get|news-badge": (option) => {
    return {
      error: false,
      data: {
        newsBadgeFlag: "1",
      },
    };
  },
};
